<template>
  <div class='MakeCardCheck'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:validTime="{ item }">
        <div> {{ `${item.validBegin} ~ ${item.validEnd}`}}</div>
      </template>
      <template v-slot:state="{ item }">
        <div> {{ statusMap[item.state] }}</div>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { handleCofirm } from '@/utils'
import { optionsDataReplace } from '@/utils'

export default {
  components: {
    SearchForm,
    Table,
    Paging,
  },
  data () {
    return {
      statusMap: {
        0: '待提审',
        1: '待审核',
        2: '通过',
        3: '驳回',
        4: '失效',
      },
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {
        }, // 返回的数据
        searchForm: [
        { type: 'Select', label: '账户类型：', prop: 'cardTypeId', width: '180px', options: [], props: this.$map.typeProps, change: row => '', placeholder: '请选择账户类型' },
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },
      Table: { // 表格
        selectionHandle: (v) => this.selectionHandle(v),
        primaryBtn: {
          show: true,
          html: '通过',
          handle: (el) => this.handleClick(el,2)
        },
        defaultBtn: {
          show: true,
          html: '驳回',
          handle: (el) => this.handleClick(el,3)
        },
        selectedList: [], // 选中的list
        data: [],
        column: [
          { type: 'selection' },
          { prop: 'cardTypeName', label: '账户类型' },
          { prop: 'rechargeDiscount', label: '活动充值折扣（%）' },
          { prop: 'minRechargeAmount', label: '基础充值金额（元）' },
          { prop: 'validTime', label: '有效期', slot: true  },
          { prop: 'state', label: '状态', slot: true },
        ]
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    searchHandleForm () {
      this.getItemList()
    },
    searchResetForm () {
      this.search.searchData = {}
    },

    getItemList () { // 获取列表
      const { pager, search } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData,
        state: 1
      }
      this.$http.discountRuleListApi(params)
        .then((res) => {
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list
          }
        })
    },

    selectionHandle (v) {
      this.Table.selectedList = v
    },

    // 账户类型
    async getCardTypeList () {
      const res = await this.$http.getCardTypeList()
      if(res && res.status === 200) {
        optionsDataReplace('cardTypeId', this.search.searchForm, (res.data || []))
      }
    },
    // 通过 & 驳回
    handleClick (el,state) { 
        if(this.Table.selectedList.length===0){
          this.$message.warning('至少选择一条数据')
          return
          }
         handleCofirm('确认当前操作?', 'type').then(async () => {
            const ids = this.Table.selectedList.map(item=>{
                return item.id
            })
            const params = {
                ids: ids.join(','),
                state 
            }
            this.$http.discountRuleStateApi(params)
            .then((res) => {
            if (res.status === 200) {
                el.clearSelection()
                this.getItemList()
                this.$message.success(res.msg || '操作成功')
            }
            }).catch((err)=>{
                this.$message.error(res.msg)
            })
        }).catch(() => { 

        })
    },

    init () {
      this.getItemList()
      this.getCardTypeList()
    }
  },
  created () {
    this.init()
  },


}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
  .el-checkbox {
    width: 25%;
    margin-right: 0;
    &:nth-child(n + 4) {
      margin-top: 20px;
    }
  }
}
</style>
